import React from 'react';
import BASE_URL from './baseUrl';

const RouteComp = (lazyImport) => {
  return React.lazy(() => {
    return lazyImport;
  });
};

const routes = [
  // public Routes
  {
    path: BASE_URL.LOGIN,
    component: RouteComp(import('../pages/login')),
    isPublic: true,
  },
  {
    path: BASE_URL.REGISTER,
    component: RouteComp(import('../pages/register')),
    isPublic: true,
  },

  // main
  {
    path: BASE_URL.REPORTS_FINANCE,
    component: RouteComp(import('../pages/reports/finance')),
    isPublic: false,
  },
  {
    path: BASE_URL.REPORTS_WAREHOUSE,
    component: RouteComp(import('../pages/reports/warehouse')),
    isPublic: false,
  },
  {
    path: BASE_URL.REPORTS_HR,
    component: RouteComp(import('../pages/reports/hr')),
    isPublic: false,
  },
  {
    path: BASE_URL.REPORTS,
    component: RouteComp(import('../pages/reports')),
    isPublic: false,
  },
  {
    path: BASE_URL.POINT_OF_SALES_TOP,
    component: RouteComp(import('../pages/pointOfSales/top')),
    isPublic: false,
  },
  {
    path: BASE_URL.POINT_OF_SALES_FO,
    component: RouteComp(import('../pages/pointOfSales/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.POINT_OF_SALES_PDF(':id'),
    component: RouteComp(import('../pages/pointOfSales/pdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.POINT_OF_SALES,
    component: RouteComp(import('../pages/pointOfSales/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.GRADES_UPLOAD,
    component: RouteComp(import('../pages/grades/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.GRADES_CREATE,
    component: RouteComp(import('../pages/grades/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.GRADES_EDIT(':id'),
    component: RouteComp(import('../pages/grades/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.GRADES,
    component: RouteComp(import('../pages/grades')),
    isPublic: false,
  },
  {
    path: BASE_URL.SERVICE_ORDER_CREATE,
    component: RouteComp(import('../pages/serviceOrder/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.SERVICE_ORDER_EDIT(':id'),
    component: RouteComp(import('../pages/serviceOrder/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.SERVICE_ORDER,
    component: RouteComp(import('../pages/serviceOrder/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.SERVICE_ORDER_FREEPORT_EDIT(':id'),
    component: RouteComp(import('../pages/freeportServiceRequest/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.SERVICE_ORDER_FREEPORT_CREATE,
    component: RouteComp(import('../pages/freeportServiceRequest/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.SERVICE_ORDER_FREEPORT,
    component: RouteComp(import('../pages/freeportServiceRequest/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_SIGNATURE_EDIT(':id'),
    component: RouteComp(import('../pages/workOrderSignature/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_SIGNATURE_CREATE,
    component: RouteComp(import('../pages/workOrderSignature/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_SIGNATURE,
    component: RouteComp(import('../pages/workOrderSignature/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.WAREHOUSE_WORK_ORDER_DETAIL_FI(':id'),
    component: RouteComp(import('../pages/warehouseWorkOrderDetail/woDetail')),
    isPublic: false,
  },
  {
    path: BASE_URL.WAREHOUSE_WORK_ORDER_DETAIL(':id'),
    component: RouteComp(import('../pages/warehouseWorkOrderDetail/woDetail')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_DETAILS_FI(':id'),
    component: RouteComp(import('../pages/workOrder/woDetailFi')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_DETAILS(':id'),
    component: RouteComp(import('../pages/workOrder/woDetail')),
    isPublic: false,
  },
  {
    path: BASE_URL.FORM_PENERIMAAN(':id'),
    component: RouteComp(import('../pages/workOrder/formPenerimaan')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_PDF_ACTION(':id'),
    component: RouteComp(import('../pages/workOrder/pdfAction')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_STICKER(':id'),
    component: RouteComp(import('../pages/workOrder/sticker')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_INVOICE_PDF(':id'),
    component: RouteComp(import('../pages/workOrder/invoicePdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_KECIL_PDF(':id'),
    component: RouteComp(import('../pages/workOrder/woKecilPdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_ESTIMATE_PDF(':id'),
    component: RouteComp(import('../pages/workOrder/pdfEstimate')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_QR_CODE_STICKER(':id'),
    component: RouteComp(import('../pages/workOrder/qrCode')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_PDF(':id'),
    component: RouteComp(import('../pages/workOrder/pdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_SUPPORT(':id'),
    component: RouteComp(import('../pages/workOrder/support')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_SERVICE_STATION(':id'),
    component: RouteComp(import('../pages/workOrder/serviceStation')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER_FI,
    component: RouteComp(import('../pages/workOrder/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.WORK_ORDER,
    component: RouteComp(import('../pages/workOrder/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.WAREHOUSE_WORK_ORDER_PDF(':id'),
    component: RouteComp(import('../pages/warehouseWorkOrder/pdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.WAREHOUSE_WORK_ORDER_FI,
    component: RouteComp(import('../pages/warehouseWorkOrder/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.WAREHOUSE_WORK_ORDER,
    component: RouteComp(import('../pages/warehouseWorkOrder/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.SPARE_PARTS_UPLOAD,
    component: RouteComp(import('../pages/items/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.SPARE_PARTS_CREATE,
    component: RouteComp(import('../pages/items/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.SPARE_PARTS_SELLING_PRICE(':id'),
    component: RouteComp(import('../pages/items/sellPrice')),
    isPublic: false,
  },
  {
    path: BASE_URL.SPARE_PARTS_PDF(':id'),
    component: RouteComp(import('../pages/items/pdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.SPARE_PARTS_EDIT(':id'),
    component: RouteComp(import('../pages/items/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.SPARE_PARTS,
    component: RouteComp(import('../pages/items/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.JOB_RATES_EDIT(':id'),
    component: RouteComp(import('../pages/jobRates/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.JOB_RATES_CREATE,
    component: RouteComp(import('../pages/jobRates/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.JOB_RATES_UPLOAD,
    component: RouteComp(import('../pages/jobRates/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.JOB_RATES,
    component: RouteComp(import('../pages/jobRates/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.POS_STATION_EDIT(':id'),
    component: RouteComp(import('../pages/posStations/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.POS_STATION_UPLOAD,
    component: RouteComp(import('../pages/posStations/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.POS_STATION_CREATE,
    component: RouteComp(import('../pages/posStations/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.POS_STATION,
    component: RouteComp(import('../pages/posStations/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.EMPLOYEES_PDF(':id'),
    component: RouteComp(import('../pages/employees/pdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.EMPLOYEES_EDIT(':id'),
    component: RouteComp(import('../pages/employees/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.EMPLOYEES_DETAIL(':id'),
    component: RouteComp(import('../pages/employees/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.EMPLOYEES_UPLOAD,
    component: RouteComp(import('../pages/employees/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.EMPLOYEES_CREATE,
    component: RouteComp(import('../pages/employees/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.EMPLOYEES,
    component: RouteComp(import('../pages/employees/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.VENDOR_UPLOAD,
    component: RouteComp(import('../pages/vendors/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.VENDOR_CREATE,
    component: RouteComp(import('../pages/vendors/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.VENDOR_EDIT(':id'),
    component: RouteComp(import('../pages/vendors/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.VENDOR,
    component: RouteComp(import('../pages/vendors/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.SHELF_DETAIL(':id'),
    component: RouteComp(import('../pages/shelfs/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.SHELF_PDF(':id'),
    component: RouteComp(import('../pages/shelfs/pdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.SHELF_EDIT(':id'),
    component: RouteComp(import('../pages/shelfs/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.SHELF_UPLOAD,
    component: RouteComp(import('../pages/shelfs/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.SHELF_CREATE,
    component: RouteComp(import('../pages/shelfs/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.SHELF,
    component: RouteComp(import('../pages/shelfs/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.PM_CHECKS_WAREHOUSE_EDIT(':id'),
    component: RouteComp(import('../pages/pmChecks/editWarehouse')),
    isPublic: false,
  },
  {
    path: BASE_URL.PM_CHECKS_WAREHOUSE,
    component: RouteComp(import('../pages/pmChecks/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.PM_CHECKS_PDF(':id'),
    component: RouteComp(import('../pages/pmChecks/pdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.PM_CHECKS_ID(':id'),
    component: RouteComp(import('../pages/pmChecks/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.PM_CHECKS_EDIT(':id'),
    component: RouteComp(import('../pages/pmChecks/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.PM_CHECKS_UPLOAD,
    component: RouteComp(import('../pages/pmChecks/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.PM_CHECKS_CREATE,
    component: RouteComp(import('../pages/pmChecks/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.PM_CHECKS,
    component: RouteComp(import('../pages/pmChecks/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.ASSETS_UPLOAD,
    component: RouteComp(import('../pages/warehouseAssets/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.ASSETS_CREATE,
    component: RouteComp(import('../pages/warehouseAssets/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.ASSETS_EDIT(':id'),
    component: RouteComp(import('../pages/warehouseAssets/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.ASSETS,
    component: RouteComp(import('../pages/warehouseAssets/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.DEPARTMENTS_CREATE,
    component: RouteComp(import('../pages/departments/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.DEPARTMENTS_EDIT(':id'),
    component: RouteComp(import('../pages/departments/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.DEPARTMENTS_DETAIL(':id'),
    component: RouteComp(import('../pages/departments/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.DEPARTMENTS,
    component: RouteComp(import('../pages/departments/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.CLASSIFICATIONS_CREATE,
    component: RouteComp(import('../pages/classifications/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.CLASSIFICATIONS_EDIT(':id'),
    component: RouteComp(import('../pages/classifications/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.CLASSIFICATIONS,
    component: RouteComp(import('../pages/classifications/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS_CREATE,
    component: RouteComp(import('../pages/contacts/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS_CONTRACTOR_ADD,
    component: RouteComp(import('../pages/contacts/createContractor')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS_EDIT(':id'),
    component: RouteComp(import('../pages/contacts/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS_ADD_CHARGE_APPROVAL(':id'),
    component: RouteComp(import('../pages/contacts/addChargeApproval')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS_EDIT_CHARGE_APPROVAL(
      ':contractId',
      ':chargeApprovalId'
    ),
    component: RouteComp(import('../pages/contacts/chargeApproval')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS_CHARGE_APPROVAL_DETAIL(':id', ':chargeApprovalId'),
    component: RouteComp(import('../pages/contacts/detailChargeApproval')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS_DETAIL(':id'),
    component: RouteComp(import('../pages/contacts/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS_CONTRACTOR_EDIT(':id'),
    component: RouteComp(import('../pages/contacts/editContractor')),
    isPublic: false,
  },
  {
    path: BASE_URL.CONTRACTS,
    component: RouteComp(import('../pages/contacts/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.CHARGE_APPROVAL_SIGNATURE_EDIT(':id'),
    component: RouteComp(
      import('../pages/chargeApprovals/editChargeApprovalSignature')
    ),
    isPublic: false,
  },
  {
    path: BASE_URL.CHARGE_APPROVAL_SIGNATURE_CREATE,
    component: RouteComp(
      import('../pages/chargeApprovals/addChargeApprovalSignature')
    ),
    isPublic: false,
  },
  {
    path: BASE_URL.CHARGE_APPROVAL_PDF(':id'),
    component: RouteComp(import('../pages/chargeApprovals/pdf')),
    isPublic: false,
  },
  {
    path: BASE_URL.CHARGE_APPROVAL_DETAIL(':id'),
    component: RouteComp(import('../pages/chargeApprovals/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.CHARGE_APPROVAL_SIGNATURE,
    component: RouteComp(import('../pages/chargeApprovals/signature')),
    isPublic: false,
  },
  {
    path: BASE_URL.CHARGE_APPROVAL,
    component: RouteComp(import('../pages/chargeApprovals/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.INVOICES_EDIT(':id'),
    component: RouteComp(import('../pages/invoices/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.INVOICES_DETAIL(':id'),
    component: RouteComp(import('../pages/invoices/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.INVOICES,
    component: RouteComp(import('../pages/invoices/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.UNIT_DETAIL(':id'),
    component: RouteComp(import('../pages/units/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.UNIT_EDIT(':id'),
    component: RouteComp(import('../pages/units/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.UNIT,
    component: RouteComp(import('../pages/units/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_MANAGER_EDIT(':id'),
    component: RouteComp(import('../pages/purchaseOrders/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_MANAGER_DETAIL(':id'),
    component: RouteComp(import('../pages/purchaseOrders/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_MANAGER_CREATE,
    component: RouteComp(import('../pages/purchaseOrders/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_MANAGER,
    component: RouteComp(import('../pages/purchaseOrders/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_APPROVAL,
    component: RouteComp(import('../pages/purchaseOrdersApproval/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_WO_DETAIL(':id'),
    component: RouteComp(import('../pages/purchaseOrders/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_WO_EDIT(':id'),
    component: RouteComp(import('../pages/purchaseOrders/editWo')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_WO_CREATE,
    component: RouteComp(import('../pages/purchaseOrders/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_WO,
    component: RouteComp(import('../pages/purchaseOrders/mainWo')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_DETAIL(':id'),
    component: RouteComp(import('../pages/purchaseOrders/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_EDIT(':id'),
    component: RouteComp(import('../pages/purchaseOrders/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER_CREATE,
    component: RouteComp(import('../pages/purchaseOrders/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.PURCHASE_ORDER,
    component: RouteComp(import('../pages/purchaseOrders/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.ATTENDANCE_UPLOAD,
    component: RouteComp(import('../pages/attendance/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.ATTENDANCE_DETAIL(':id'),
    component: RouteComp(import('../pages/attendance/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.ATTENDANCE,
    component: RouteComp(import('../pages/attendance/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.ACCOUNTS_EDIT(':id'),
    component: RouteComp(import('../pages/accounts/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.ACCOUNTS_CREATE,
    component: RouteComp(import('../pages/accounts/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.ACCOUNTS,
    component: RouteComp(import('../pages/accounts/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.HOLIDAY_EDIT(':id'),
    component: RouteComp(import('../pages/payroll/editHoliday')),
    isPublic: false,
  },
  {
    path: BASE_URL.HOLIDAY_CREATE,
    component: RouteComp(import('../pages/payroll/createHoliday')),
    isPublic: false,
  },
  {
    path: BASE_URL.PAYROLL_DETAIL_PDF(':id'),
    component: RouteComp(import('../pages/payroll/pdfPayroll')),
    isPublic: false,
  },
  {
    path: BASE_URL.PAYROLL_DETAIL(':id'),
    component: RouteComp(import('../pages/payroll/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.PAYROLL_UPLOAD,
    component: RouteComp(import('../pages/payroll/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.PAYROLL,
    component: RouteComp(import('../pages/payroll/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.VOUCHERS_EDIT(':id'),
    component: RouteComp(import('../pages/accounting/editVoucher')),
    isPublic: false,
  },
  {
    path: BASE_URL.VOUCHERS_CREATE,
    component: RouteComp(import('../pages/accounting/createVoucher')),
    isPublic: false,
  },
  {
    path: BASE_URL.ACCOUNTING_DETAIL(':id'),
    component: RouteComp(import('../pages/accounting/detail')),
    isPublic: false,
  },
  {
    path: BASE_URL.ACCOUNTING_EDIT(':id'),
    component: RouteComp(import('../pages/accounting/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.ACCOUNTING_CREATE,
    component: RouteComp(import('../pages/accounting/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.ACCOUNTING,
    component: RouteComp(import('../pages/accounting/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.REQUEST_ITEM_BOS,
    component: RouteComp(import('../pages/requestItem/bos')),
    isPublic: false,
  },
  {
    path: BASE_URL.REQUEST_ITEM_EDIT(':id'),
    component: RouteComp(import('../pages/requestItem/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.REQUEST_ITEM_OTHER,
    component: RouteComp(import('../pages/requestItem/other')),
    isPublic: false,
  },
  {
    path: BASE_URL.REQUEST_ITEM_CREATE,
    component: RouteComp(import('../pages/requestItem/create')),
    isPublic: false,
  },
  {
    path: BASE_URL.REQUEST_ITEM,
    component: RouteComp(import('../pages/requestItem/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.SUPPORT_DOCS_EDIT(':id'),
    component: RouteComp(import('../pages/supportDocs/edit')),
    isPublic: false,
  },
  {
    path: BASE_URL.SUPPORT_DOCS,
    component: RouteComp(import('../pages/supportDocs/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.NOTIFICATIONS,
    component: RouteComp(import('../pages/notifications/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.LOGGING,
    component: RouteComp(import('../pages/logging/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.CAR_WASH,
    component: RouteComp(import('../pages/carWash/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.TIME_SHEETS_UPLOAD,
    component: RouteComp(import('../pages/timeSheets/upload')),
    isPublic: false,
  },
  {
    path: BASE_URL.TIME_SHEETS,
    component: RouteComp(import('../pages/timeSheets/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_CHARGE_APPROVAL_ID(':id'),
    component: RouteComp(import('../pages/linkTree/createChargeApproval')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_CHARGE_APPROVAL_LIST_ID(':id'),
    component: RouteComp(import('../pages/chargeApprovalTracking')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_CHARGE_APPROVAL,
    component: RouteComp(import('../pages/chargeApprovalTracking')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_REQUEST_ITEMS_CREATE,
    component: RouteComp(import('../pages/linkTree/createRequestItems')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_REQUEST_ITEMS_CREATE_ID(':id'),
    component: RouteComp(import('../pages/linkTree/createRequestItems')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_REQUEST_ITEMS_ID(':id'),
    component: RouteComp(import('../pages/linkTree/requestItems')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_REQUEST_ITEMS,
    component: RouteComp(import('../pages/linkTree/requestItems')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_WORK_ORDER_ID(':id'),
    component: RouteComp(import('../pages/linkTree/createWorkOrders')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_WORK_ORDER_CREATE,
    component: RouteComp(import('../pages/linkTree/createWorkOrders')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_WORK_ORDER_LIST_ID(':id'),
    component: RouteComp(import('../pages/linkTree/workOrders')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_WORK_ORDER,
    component: RouteComp(import('../pages/linkTree/workOrders')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE_ID(':id'),
    component: RouteComp(import('../pages/linkTree/mainId')),
    isPublic: false,
  },
  {
    path: BASE_URL.LINK_TREE,
    component: RouteComp(import('../pages/linkTree/main')),
    isPublic: false,
  },
  {
    path: BASE_URL.HOME,
    component: RouteComp(import('../pages/serviceOrder/main')),
    isPublic: false,
  },
];

export default routes;
